import React, { useReducer, useState } from 'react'
import {
  FilterAutocomplete,
  IFilterAutocompleteProp,
  initialRequestState,
  IRequestAction,
  IRequestState,
  isAutosuggestResult,
  ISuggestResult,
  loadSuggestions,
  requestReducer,
} from 'transfix-ui/components/FilterAutocomplete'
import { useDebouncedCallback } from 'use-debounce/lib'
import { UserIcon } from 'transfix-icons'

type IReducerState = (state: IRequestState, action: IRequestAction) => IRequestState

interface IAdminFilterAutocomplete {
  onSelectedValue: (val: IFilterAutocompleteProp) => void
  label?: string
  toggleClear?: boolean
  userType?: 'user' | 'transfix_admin'
}

/**
 * Autocomplete filter for selecting Admins
 */
const AdminFilterAutocomplete = ({
  label = 'User',
  onSelectedValue: onSelectedValueProps,
  toggleClear = false,
  userType = 'user',
}: IAdminFilterAutocomplete) => {
  const [value, setValue] = useState<ISuggestResult | undefined | null>()
  const resultMatch = (a?: ISuggestResult, b?: ISuggestResult) => a?.name === b?.name
  const searchResultLabel = (e: ISuggestResult) => e.name

  const setValueHandler = (val: IFilterAutocompleteProp) => {
    if (isAutosuggestResult(val)) {
      setValue(val)
    } else {
      setValue(null)
    }
    onSelectedValueProps(val)
  }

  const [stateAdmin, dispatchAdmin] = useReducer<IReducerState>(requestReducer, initialRequestState)

  const [debounceSearchAdmin] = useDebouncedCallback((_: React.ChangeEvent<{}>, value: string) => {
    loadSuggestions({ value, type: userType, dispatch: dispatchAdmin })
  }, 250)

  return (
    <FilterAutocomplete
      id='admin-filter-autocomplete'
      label={label}
      placeholder='Search'
      dataTest='admin-filter-autocomplete'
      options={stateAdmin.results || []}
      value={value}
      setValue={setValueHandler}
      onInputChange={debounceSearchAdmin}
      getOptionLabel={searchResultLabel}
      getOptionSelected={resultMatch}
      quickSuggest
      autoSelect={false}
      resultsLoading={stateAdmin.loading}
      toggleClear={toggleClear}
      icon={<UserIcon size='large' />}
    />
  )
}

export default AdminFilterAutocomplete
